import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Calendar,
  ArrowLeft,
  HelpCircle,
  Hash,
  Clock,
  CreditCard,
  Link2,
  FileText,
  User,
  Tag,
  Home,
  Send,
  Truck,
  MessageSquare,
  Box,
  Plus,
  Minus,
  Shuffle,
  Database,
  Percent,
  Trash2,
  RotateCcw,
  Printer,
  Check,
} from "feather-icons-react/build/IconComponents";
import {
  getTaxList,
  getUnitList,
  getCustomersList,
  getDiscountList,
  getWareHouseList,
} from "../../../services/MasterApiServices";
import "../../../style/css/sales-invoice-modal.css";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { InvSales } from "../../../core/json/invSales";
import { InvSalesDetail } from "../../../core/json/invSalesDetail";
import { DiscountClass } from "../../../core/json/Discount";
import {
  addEditSales,
  getSalesByTransType,
} from "../../../services/SalesApiServices";
import { ProductClass } from "../../../core/json/Product";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { TaxClass } from "../../../core/json/TaxClass";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchCustomer,
  fetchSettings,
} from "../../../redux/userSetting";
import CustomerModal from "../../master/modal/CustomerModal";
import { FinancialYear } from "../../../core/json/FinancialYear";
import { fetchBranchSettings } from "../../../redux/settingbyBranch";
import QRCode from "qrcode";
import { Buffer } from "buffer";
import { getPrintSettingsByBranch } from "../../../services/AdminApiServices";

const DeliveryNoteModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      paymentType: 0,
      salesMode: 0,
      addition: 0,
      refNo: "0",
      subtraction: 0,
      round: 0,
      referencetype: 0,
    },
    mode: "onBlur",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: "0.0",
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      // hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0",
      unit: "",
      product: null,
    });
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchCustomer(branch));
      dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, []);

  const [discountList, setdiscountList] = useState([]);

  const [taxData, setTaxData] = useState([]);
  const [discountData, setdiscountData] = useState([]);
  const [unitData, setunitData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [salesData, setsalesData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const { branchsettings } = useSelector((state) => state.settings);
  const [printAfterSubmit, setPrintAfterSubmit] = useState(false);
  const [printSettings, setPrintSettings] = useState([]);
  const { productList, unitList, taxList, customerList, settingList, productAllList,formatedproductListAll,
    formatedproductList,
   } =
    useSelector((state) => state.usersetting);

  const referencetype = [
    { value: 0, label: "DIRECT" },
    { value: 2, label: "ORDER" },
  ];
  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Credit" },
    { value: 2, label: "UPI" },
    { value: 3, label: "Card" },
  ];

  const salesMode = [
    { value: 0, label: "NORMAL SERIES" },
    { value: 1, label: "QUOT SERIES" },
  ];


  const [warehouses, setWarehouses] = useState([]);
  
  useEffect(() => {
    const fetchPrintSettings = async () => {
      try {
        const response = await getPrintSettingsByBranch(branch?.guid);
        setPrintSettings(response);
      } catch (error) {
        console.error("Failed to fetch print settings", error);
      }
    };
  
    if (branch?.guid) {
      fetchPrintSettings();
    }
  }, [branch]);

useEffect(() => {
  const fetchWarehouses = async () => {
    try {
      const response = await getWareHouseList();

      if (Array.isArray(response)) {
        // Filter warehouses by current branch
        const filtered = response.filter(
          (wh) => wh.branchID === branch?.guid
        );
        setWarehouses(filtered);
      } else {
        setWarehouses([]);
      }
    } catch (err) {
      console.error("Failed to fetch warehouses:", err);
    }
  };
  if (branch?.guid) {
    fetchWarehouses();
  }
}, [branch]);
  
const formattedWarehouses = Array.isArray(warehouses)
  ? warehouses.map((warehouse) => ({
      label: warehouse.name || "Unnamed Warehouse",
      value: warehouse,
    }))
  : [];

// Helper function to get selected warehouse option
const getSelectedWarehouseOption = (warehouse) => {
  if (!warehouse) return null;
  return (
    formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
      label: warehouse.name || "Select Warehouse",
      value: warehouse,
    }
  );
};



  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;

  fields.forEach((field, index) => {
    const quantity = watch(`items[${index}].quantity`, 0);
    const price = watch(`items[${index}].price`, 0);
    const discount = watch(`items[${index}].discountPercentage`, 0);
    const taxGUID = watch(`items[${index}].taxPercentage`, 0);
    const tax = taxData.find((t)=>t.guid==taxGUID)?.value || 0;
    const grossTl = price * quantity || 0;
    const discountAmt = (grossTl * discount) / 100 || 0;
    const amountBeforeTax = grossTl - discountAmt || 0;
    const taxAmount = (amountBeforeTax * tax) / 100 || 0;
    const netTotal = amountBeforeTax + taxAmount || 0;

    setValue(`items[${index}].gross`, grossTl?.toFixed(decimalpoints));
    setValue(
      `items[${index}].discountAmount`,
      discountAmt?.toFixed(decimalpoints)
    );
    setValue(`items[${index}].taxAmount`, taxAmount?.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, netTotal?.toFixed(decimalpoints));

    // Add to totalGross
    totalGross += grossTl;
    totalDiscount += discountAmt;
    totalTax += taxAmount;
    totalNet += netTotal;
  });
  //Final calculations on addition ,discount and round
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));

  totalNet += safeNumber(addition);
  totalNet -= safeNumber(subtraction);
  totalNet -= safeNumber(round);
  totalDiscount = totalDiscount + safeNumber(subtraction);
 
  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();

      const formattedDiscount = response?.map((discount) => ({
        label: discount.percentage,
        value: discount.percentage,
        guid: discount.guid,
      }));
      setdiscountData(formattedDiscount);
    } catch (error) {
      console.error("Error fetching discount", error);
    }
  };

  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
    console.log(formatedproductList,"proooooooooo");
console.log(productList,"produccccccc");
//console.log(formatedproductListAll,"prooooooooooall");
  };

  const handleTaxList = async () => {
    try {
      const response = await getTaxList();

      const formattedTax = response?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(formattedTax);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].taxPercentage`,productData?.taxID);
      setValue(`items[${index}].price`, productData?.retailRate|| 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.find(
        (product) => product.guid === guid
      );
      return filteredData;
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  }

  const handleCustomerList = async () => {
    try {
      // const response = await getCustomersList(branch);
      const formattedCustomers = customerList?.map((customer) => ({
        label: customer.name,
        value: customer.guid,
      }));
      setCustomerData(formattedCustomers);
    } catch (error) {
      console.error(
        "Error fetching customers",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 1);
      setsalesData(response.data);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEntryNo = async () => {
    try {
      const response = await getSalesByTransType(branch, 1);
      const salesData = response.data;

      // Group entry numbers by prefix
      const entryGroups = salesData.reduce((groups, data) => {
        const entrynumber = data.entrynumber;
        // Extract the prefix (non-numeric characters)
        const prefix = entrynumber.match(/^[A-Za-z]+/)[0];
        // Extract the numeric part and convert it to an integer
        const entryNum = parseInt(entrynumber.replace(/\D/g, ""), 10);

        if (!groups[prefix]) {
          groups[prefix] = [];
        }
        groups[prefix].push(entryNum);

        return groups;
      }, {});

      // Get the desired prefix (e.g., "SQ")
      const prefix = "DN";
      const maxEntryNumber =
        entryGroups[prefix]?.length > 0 ? Math.max(...entryGroups[prefix]) : 0;

      // Increment the counter for the prefix
      const counter = maxEntryNumber + 1;

      // Set the new entry number with the updated counter
      //setValue(`entrynumber`, `${prefix}2`);
      setValue(`entrynumber`, `${prefix}${counter}`);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     setValue("terms", data.terms);
  //     setValue("entrynumber", data.entrynumber);
  //     setValue("salesMode", data.salesMode || 0);
  //     setValue("salesTransType", data.salesTransType || 1);
  //     setValue("referencetype", data.reftype || 0);
  //     setValue("refNo", data.refNo || 0);
  //     setValue("dispatch", data.dispatch || "");
  //     setValue("dispatchTrough", data.dispatchTrough || "");
  //     setValue("terms", data.terms || "");
  //     setValue("addition", data.additionalAmt || 0);
  //     setValue("subtraction", data.discAmt || 0);
  //     setValue("round", data.roundOff || 0);
  //     setValue("grossTotal", data.grossTotal || 0);
  //     setValue("discountTotal", data.discountTotal || 0);
  //     setValue("taxTotal", data.taxTotal || 0);
  //     setValue("netAmt", data.netAmt || 0);
  //     setValue("paymentType", data.salesPaymentType || 0);
  //     setValue("customer", data.customer.guid);
  //     setValue("invdate", dayjs(data.invdate) || dayjs());
  //     setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
  //  if (data.location?.guid) {
  //     const selectedWarehouse = getSelectedWarehouseOption(data.location);
  //     setValue("location", selectedWarehouse.value || data.location);
  //   }
  //     setValue(
  //       "items",
  //       data?.invSalesDetails?.map((detail, i) => ({
  //         product: detail?.product?.guid,
  //         code: detail?.product?.code,
  //         // hsnCode: detail?.product?.hsnCode || 0,
  //         batch: detail.batch,
  //         expiry: dayjs(detail.expiryDate),
  //         unit: detail.unit?.guid,
  //         quantity: detail.quantity,
  //         price: detail.price,
  //         mrp: detail.mrp,
  //         foc: detail.foc,
  //         discountPercentage: detail.discPercentage,
  //         discountAmount: detail.discAmt,
  //         taxPercentage: detail.taxPercentage,
  //         gross: detail.gross,
  //         taxAmount: detail.taxamnt,
  //         netTotal: detail.netAmt,
  //       }))
  //     );
  //   } else {
  //     reset();
  //     handleEntryNo();
  //   }
  // }
  // useEffect(() => {
  //   resetmodal();
  // }, [data, setValue]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (mode === "add") {
  //       handleEntryNo();
  //       if (!isRowAdded && fields?.length === 0) {
  //         handleAddRow();
  //         setIsRowAdded(true);
  //       }
  //     }
  //     handleProductsList();
  //     handleTaxList();
  //     handleUnitList();
  //     handlesalesData();
  //     handleDiscountList();
  //   };
  //   fetchData();
  
  // }, []);

      async function resetmodal() {
      if (mode === "edit" && data) {
        setValue("terms", data.terms);
        setValue("entrynumber", data.entrynumber);
        setValue("salesMode", data.salesMode || 0);
        setValue("salesTransType", data.salesTransType || 2);
        setValue("paid", data.paid || 0);
        setValue("change", Number(data.change) || 0);
        setValue("refNo", data.refNo || 0);
        setValue("dispatch", data.dispatch || "");
        setValue("dispatchTrough", data.dispatchTrough || "");
        setValue("addition", data.additionalAmt || 0);
        setValue("subtraction", data.discAmt || 0);
        setValue("round", data.roundOff || 0);
        setValue("grossTotal", data.grossTotal || 0);
        setValue("discountTotal", data.discountTotal || 0);
        setValue("taxTotal", data.taxTotal || 0);
        setValue("netAmt", data.netTotal || 0);
        setValue("paymentType", data.salesPaymentType || 0);
        setValue("referencetype", data.reftype || 0);
        setValue("customer", data.customer.guid);
        setValue("customerContactno", data.customerContactno || "0");
        setValue("customerName", data.customerName || "");
        setValue("invdate", dayjs(data.invdate) || dayjs());
        setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
       if (data.location?.guid) {
          const selectedWarehouse = getSelectedWarehouseOption(data.location);
          setValue("location", selectedWarehouse.value || data.location);
        }
        // Map items properly
        const items = data.invSalesDetails.map((detail) => {
          const taxGuid =
            taxData.find((t) => Number(t.value) === Number(detail.taxPercentage))
              ?.guid || null;
    
          return {
            product: detail?.product?.guid,
            code: detail?.product?.code,
            batch: detail.batch,
            expiry: dayjs(detail.expiryDate),
            unit: detail.unit?.guid,
            quantity: detail.quantity,
            price: detail.price,
            mrp: detail.mrp,
            foc: detail.foc,
            discountPercentage: detail.discPercentage,
            discountAmount: detail.discAmt,
            taxPercentage: taxGuid, // GUID of the tax
            gross: detail.gross,
            taxAmount: detail.taxamnt,
            netTotal: detail.netAmt,
          };
        });
    
        setValue("items", items);
      }
    }
    
    useEffect(() => {
      if (data && taxData.length) {
        resetmodal();
      }
    }, [data, taxData]);
    
  useEffect(() => {
  const fetchData = async () => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }

      // Set default warehouse
      if (branchsettings?.defaultWareHouseID) {
        const defaultWH = warehouses.find(
          (wh) => wh.guid === branchsettings.defaultWareHouseID
        );
        if (defaultWH) {
          const selectedWarehouse = getSelectedWarehouseOption(defaultWH);
          setValue("location", selectedWarehouse.value);
        }
      }
    }
    handleProductsList();
    handleTaxList();
    handleUnitList();
    handlesalesData();
    handleDiscountList();
  };

  fetchData();
}, [branchsettings, warehouses]);

  useEffect(() => {
    handleCustomerList();
  }, [customerList]);

  const [products, setProducts] = useState([]);

  const handleProductsList = async () => {
    try {
      const formattedProducts = productList?.map((product) => ({
        label: product.name,
        value: product.guid,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  useEffect(() => {
    dispatch(fetchBranchSettings(branch.guid));
  }, [branch]);
  async function getCustomerByGuid(guid) {
    const response = await getCustomersList(branch);
    const filteredData = response.data?.filter(
      (customer) => customer.guid === guid
    );
    return filteredData[0];
  }
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const handleFormSubmit = async (formdata) => {
    const objsales = new InvSales();
    if (mode === "edit") {
      objsales.guid = data.guid;
      objsales.id = data.id;
    }
    objsales.entrynumber = formdata.entrynumber || 0;
    objsales.branch = branch;
    objsales.invdate = dayjs(formdata.invdate)?.format("YYYY-MM-DDTHH:mm:ss");
    objsales.deliveryDate = dayjs(formdata.deliveryDate)?.format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    objsales.salesPaymentType = formdata.paymentType;
    objsales.salesTransType = 1;
    objsales.refNo = formdata.refNo || "";
    const customerData = customerList?.find((e) => e.guid == formdata.customer);
    objsales.location = formdata.location;
    objsales.updatedUser = `${userId?.id}`;
    objsales.createdUser = `${userId?.id}`;
    objsales.customer = customerData;
    objsales.currency = "00000000-0000-0000-0000-000000000000";
    objsales.salesMode = formdata.salesMode || 0;
    objsales.additionalAmt = Number(formdata.addition) || 0.0;
    objsales.discAmt = Number(formdata.subtraction) || 0;
    objsales.roundOff = Number(formdata.round) || 0;
    objsales.grossTotal = totalGross || 0.0;
    objsales.discountTotal = totalDiscount || 0.0;
    objsales.dispatch = formdata.dispatch || "";
    objsales.dispatchTrough = formdata.dispatchTrough || "";
    objsales.terms = formdata.terms || "";
    objsales.taxTotal = totalTax || 0.0;
    objsales.netTotal = totalNet || 0.0;
    if (formdata.paymentType === 0) {
      objsales.cash = totalNet || 0;
    } else if (formdata.paymentType === 1) {
      objsales.bank = totalNet || 0;
    } else if (formdata.paymentType === 2) {
      objsales.upi = totalNet || 0;
    } else if (formdata.paymentType === 3) {
      objsales.card = totalNet || 0;
    }
    const objfinance = new FinancialYear();
    objfinance.id = branchsettings?.defaultFinancialYearID;
    objsales.financialYear = objfinance;
    objsales.Company = companyInfolist[0];
    const detailObj = formdata?.items?.map((e) => {
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;
      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList.find((item) => item.guid == e.unit);
      const taxPercentage=taxData?.find((item)=>item.guid==e.taxPercentage)?.value
      const discountValue = discountData?.find(
        (discount) => discount.value === e.discountPercentage
      );
      const discount = discountValue
        ? discountList?.find((item) => item.guid == discountValue.guid)
        : defaultDiscountobj;
      const taxValue = taxData?.find((tax) => tax.value === e.taxPercentage);
      const tax = taxValue
        ? taxList?.find((item) => item.guid == taxValue.guid)
        : defaultTaxobj;

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        unit,
        batch: e.batch,
        expiryDate: expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp || 0.0,
        foc: e.foc || 0.0,
        taxamnt: e.taxAmount,
        grossAmount: e.gross,
        netAmt: e.netTotal,
        discAmt: e.discountAmount,
        discPercentage: e.discountPercentage,
        taxPercentage
      };

      return detailObj;
    });
    objsales.invSalesDetails = detailObj;
    try {
      const response = await addEditSales(objsales);
      if (response) {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal
                         if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

      // const generateFatooraQR = (sellerName, vatNumber, invoiceDate, invoiceTotal, vatTotal) => {
      //   const encodeTLV = (tag, value) => {
      //     const encodedTag = Buffer.from([tag]).toString("hex");
      //     const encodedLength = Buffer.from([value.length]).toString("hex");
      //     const encodedValue = Buffer.from(value, "utf-8").toString("hex");
      //     return encodedTag + encodedLength + encodedValue;
      //   };
      
      //   const qrDataHex =
      //     encodeTLV(1, sellerName) +
      //     encodeTLV(2, vatNumber) +
      //     encodeTLV(3, invoiceDate) +
      //     encodeTLV(4, invoiceTotal) +
      //     encodeTLV(5, vatTotal);
      
      //   const qrDataBase64 = Buffer.from(qrDataHex, "hex").toString("base64");
      //   return qrDataBase64;
      // };

    const generateFatooraQR = (sellerName, invoiceDate, invoiceTotal, vatTotal) => {
      const encodeTLV = (tag, value) => {
        const safeValue = value ? String(value) : "";
        const tagBuffer = Buffer.from([tag]);
        const lengthBuffer = Buffer.from([safeValue.length]);
        const valueBuffer = Buffer.from(safeValue, "utf8");
    
        return Buffer.concat([tagBuffer, lengthBuffer, valueBuffer]);
      };
    
      const qrBuffer = Buffer.concat([
        encodeTLV(1, sellerName),
        encodeTLV(2, invoiceDate),
        encodeTLV(3, invoiceTotal),
        encodeTLV(4, vatTotal),
      ]);
    
      return qrBuffer.toString("base64");
    };


      const printA4Function = async() => {
        const form = document.getElementById("invoice-content");
      
        if (!form) {
          console.error("Element with ID 'invoice-content' not found.");
          return;
        }
    
        // const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
    
        // // Extract company details
        // const companyName = company.name || "Company Name";
        // const companyAddress1 = company.address1 || "";
        // const companyAddress2 = company.address2 || "";
        // const companyAddress3 = company.address3 || "";
        // const companyPhone = company.phone || "";
        // const companyVAT = company.tin || "";
        // Extract values from form inputs
        
    const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
        
             const supplierGuid = watch("customer");
       const supplierObj = customerList.find(sup => sup.guid === supplierGuid) || {};
       const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
       const supplierAddress1 = supplierObj.address1 || "";
       const supplierMobile = supplierObj.mobile || "";
       const supplierVAT = supplierObj.gstNo || "";   
        
        const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
    
    const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
    const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
    const invDateValue = watch("invdate") || new Date().toISOString();
      const invoiceDate = new Date(invDateValue).toISOString();
        const customerName = form.querySelector("input[name='customerName']")?.value || "";
        const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
        const fields = watch("items") || [];
    // const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
    // const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
    const  netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);
    // const addition = parseFloat(watch("addition")) || 0;
    // const round = parseFloat(watch("round")) || 0;
    // Store the totals in React Hook Form
    // setValue("discount", discount.toFixed(2));
    // setValue("taxTotal", taxTotal.toFixed(2));
    // setValue("netTotal", netTotal.toFixed(2));
    
    const grossTotalPrint = Number(totalGross) || 0;
    const discountPrint = Number(totalDiscount) || 0;
    const taxTotalPrint = Number(totalTax) || 0;
    const netTotalPrint = Number(totalNet) || 0;
    
    const additionPrint = Number(watch("addition")) || 0;
    const roundPrint = Number(watch("round")) || 0;
    
    
    console.log({ totalDiscount, totalTax, totalNet });
    
      
        // Extract table data
      
    
      // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
      //   // Query the react-select component for the current row
      //   const selectContainer1 = row?.querySelector('.css-b62m3t-container');
      //   const selectContainer = selectContainer1?.querySelector('.react-select__control');
      //   const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
      //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
      
      //   // Extract the text or value of the selected option
      //   const selectedValue = selectedValueDiv?.textContent || "N/A";
      
      //   // Extract other values from the row (quantity, rate, total)
      //   return {
      //     description: selectedValue,
      //     qty: parseInt(row.querySelector("td:nth-child(6) input")?.value?.trim()) || 0,
      //     rate: parseFloat(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0.00,
      //     total: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00
      //   };
      // });
    const paymentTypeLabel =
      paymentType?.find(p => p.value === watch("paymentType"))?.label || "";
    
    
      //     const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row, index) => ({
      //   description: row.querySelector('td[data-label="Description"]')?.innerText || "",
      //   code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
      //   hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
      //   qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
      //   unit: row.querySelector('td[data-label="Unit"] input')?.value || "",
      //   rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
      //   discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
      //   tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
      //   total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
      //   netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
      // }));
      const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row) => {
      const unitText =
        row
          .querySelector('td[data-label="Unit"] .react-select__single-value')
          ?.textContent || "";
    
      return {
        description: row.querySelector('td[data-label="Description"]')?.innerText || "",
        code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
        qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
        unit: unitText,
        rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
        tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
          discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
        total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
        netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
      };
    });
    
      console.log(tableRows,"lkkk");
    
      // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;
        
      //   const qrCodeUrl = await QRCode.toDataURL(qrData);
    
      const fatooraQRData = generateFatooraQR(companyName, invoiceDate, netTotalPrint.toFixed(2), taxTotalPrint.toFixed(2));
      const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);
    
    
    const amountInWords = (num) => {
      if (!num || isNaN(num)) return "";
    
      const a = [
        "", "One", "Two", "Three", "Four", "Five",
        "Six", "Seven", "Eight", "Nine", "Ten",
        "Eleven", "Twelve", "Thirteen", "Fourteen",
        "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
      ];
    
      const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    
      const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000)
          return (
            a[Math.floor(n / 100)] +
            " Hundred" +
            (n % 100 ? " " + numberToWords(n % 100) : "")
          );
        if (n < 1000000)
          return (
            numberToWords(Math.floor(n / 1000)) +
            " Thousand" +
            (n % 1000 ? " " + numberToWords(n % 1000) : "")
          );
        return "";
      };
    
      const integerPart = Math.floor(num);
      const decimalPart = Math.round((num - integerPart) * 100);
    
      const riyalPart = numberToWords(integerPart);
      const halalahPart = decimalPart ? numberToWords(decimalPart) : "";
    
      return `${riyalPart} Riyal${
        halalahPart ? " and " + halalahPart + " Halalah" : ""
      } Only`;
    };
    
    
    const printableContent = `
    <!DOCTYPE html>
    <html lang="ar">
    <head>
    <meta charset="UTF-8" />
    <title>Tax Invoice</title>
    
    <style>
    @page { size: A4; margin: 10mm; }
    
    body {
      font-family: Arial, sans-serif;
      font-size: 11px;
      color: #000;
    }
    
    .center { text-align: center; }
    .left { text-align: left; direction: ltr; }
    .right { text-align: right; direction: rtl; }
    .bold { font-weight: bold; }
    
    .header p { margin: 2px 0; }
    .header h2 { margin: 4px 0; }
    
    .invoice-title {
      margin: 16px 16px;
      font-weight: bold;
      
    }
    
    /* DEFAULT TABLE */
    table {
      width: 100%;
      border-collapse: collapse;
    }
    
    /* HEADER & INFO TABLES */
    th {
      border: 1px solid #000;
      padding: 4px;
    }
    
    .header table td,
    table:not(.items) td {
      border: 1px solid #000;
      padding: 4px;
    }
    
    /* ITEMS TABLE OUTER BORDER */
    .items {
      border: 1px solid #000;
    }
    
    /* ITEM HEADER GRID */
    .items thead th {
      border: 1px solid #000;
    }
    
    /* ITEM BODY — NO VERTICAL LINES */
    /* ITEM BODY — ONLY VERTICAL LINES (REFERENCE STYLE) */
    .items tbody td {
      border-top: none;
      border-bottom: none;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
      padding: 6px 4px;
      text-align: center;
      height: 26px;
    }
    
    
    
    
    /* BOTTOM BORDER OF ITEMS */
    .items tbody tr:last-child td {
      border-bottom: 1px solid #000;
    }
    
    
    .small { font-size: 10px; }
    
    .no-border tr td { border: none; }
    
    .items th { font-size: 10px; }
    .items td { font-size: 11px; text-align: center; }
    
    /* FORCE ITEM TABLE HEIGHT */
    .items tbody {
      height: 460px;
    }
    .totals{
    border: 1px solid #000;
    }
    .totals tr td {
       border-top: none;
      border-bottom: none;
      border-left: none;
      border-right: none;
      padding: 6px 4px;
    }
    .totals td:last-child {
      border-left: 1px solid #000;
    }
    
    .footer-fixed {
      margin-top: 18px;
      font-size: 10px;
    }
    
    .footer-fixed tr td {
      border: none;
    }
    </style>
    </head>
    
    <body>
    
    <!-- HEADER (UNCHANGED AS REQUESTED) -->
    <div class="header center">
   <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
    
    
      <div class="invoice-title">TAX INVOICE &nbsp;&nbsp; الفاتورة الضريبية</div>
    </div>
    
    <!-- INVOICE INFO -->
    <table>
    <tr>
      <td class="left small"><b>Delivery Note No :</b> ${entryNumber}</td>
      <td class="center small"><b>Date :</b> ${date}</td>
      <td class="right small"><b>Type :</b> ${paymentTypeLabel}</td>
    </tr>
    </table>
    
    <!-- CUSTOMER DETAILS -->
    <table style="margin-top:4px;">
    <tr>
      <th colspan="4" class="center small">CUSTOMER DETAILS &nbsp;&nbsp; تفاصيل العميل</th>
    </tr>
    <tr>
      <td class="left small"><b>NAME</b></td>
      <td class="left">${supplierName}</td>
      <td></td>
      <td class="right small"><b>اسم</b></td>
    
    </tr>
    <tr>
      <td class="left small"><b>CONTACT</b></td>
      <td class="left">${supplierMobile}</td>
      <td>${supplierMobile}</td>
      <td class="right small"><b>رقم الاتصال</b></td> 
    </tr>
    <tr>
      <td class="left small"><b>VAT NO</b></td>
      <td class="left">${supplierVAT}</td>
        <td>${supplierVAT}</td>
      <td class="right small"><b>الرقم الضريبي</b></td>
    
    </tr>
    <tr>
      <td class="left small"><b>CR NO</b></td>
      <td class="left"></td>
        <td></td>
      <td class="right small"><b>رقم السجل التجاري</b></td>
    
    </tr>
    <tr>
      <td class="left small"><b>ADDRESS</b></td>
      <td colspan="3">${supplierAddress1}</td>
    </tr>
    </table>
    
    <!-- ITEMS -->
    <table class="items" style="margin-top:4px;">
    <thead>
    <tr>
      <th>Sl.No<br/>رقم</th>
      <th>Barcode<br/>الباركود</th>
      <th>Description<br/>الوصف</th>
      <th>Qty<br/>كمية</th>
      <th>Unit<br/>وحدة</th>
      <th>Unit Price<br/>سعر الوحدة</th>
      <th>Taxable Amt<br/>المبلغ الخاضع</th>
      <th>Tax Amt<br/>مبلغ الضريبة</th>
      <th>Total<br/>المجموع</th>
    </tr>
    </thead>
    
    <tbody>
    ${
    (() => {
      const minRows = 9;
      const emptyRows = minRows - tableRows.length;
    
      return `
      ${tableRows.map((row, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${row.code}</td>
        <td class="left">${row.description}</td>
        <td>${row.qty}</td>
        <td>${row.unit}</td>
        <td>${row.rate.toFixed(2)}</td>
        <td>${row.total.toFixed(2)}</td>
        <td>${row.tax.toFixed(2)}</td>
        <td>${row.netTotal.toFixed(2)}</td>
      </tr>
      `).join("")}
    
      ${Array.from({ length: Math.max(0, emptyRows) }).map(() => `
      <tr>
        <td>&nbsp;</td><td></td><td></td><td></td>
        <td></td><td></td><td></td><td></td><td></td>
      </tr>
      `).join("")}
      `;
    })()
    }
    </tbody>
    </table>
    
    <!-- TOTALS -->
    <table class="totals" style="margin-top:6px;">
    <tr>
      <td class="left small">
    VAT (${((taxTotalPrint / (netTotalPrint - taxTotalPrint)) * 100).toFixed(2)}%)
      </td>
      <td></td>
      <td class="right bold" style="padding-right:16px;">Total</td><td>المجموع</td> 
      <td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td class="right bold" style="padding-right:16px;">VAT</td><td>ضريبة القيمة المضافة</td> 
      <td class="right">${taxTotalPrint.toFixed(2)}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td class="right bold" style="padding-right:16px;">Discount </td><td> تخفيض</td> 
      <td class="right">${discountPrint.toFixed(2)}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td class="right bold" style="padding-right:16px;">Sub Total </td><td>المجموع الفرعي</td> 
      <td class="right">${netTotal.toFixed(2)}</td>
    </tr>
    
    <tr>
      <td colspan="2"></td>
      <td class="right bold" style="padding-right:16px;">Addition</td><td>إضافة</td> 
      <td class="right">${additionPrint.toFixed(2)}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td class="right bold" style="padding-right:16px;">Round off</td><td >تقريب</td> 
      <td class="right">${roundPrint.toFixed(2)}</td>
    </tr>
    <tr>
      <td class="left bold">
         ${amountInWords(netTotalPrint)}
      </td>
      <td></td>
      <td class="right bold" style="padding-right:16px;">Net Total</td><td class="bold">صافي المجموع</td> 
      <td class="right bold">${netTotalPrint.toFixed(2)}</td>
    </tr>
    </table>
    
    <!-- QR & FOOTER -->
    <table class="footer-fixed">
    <tr>
      <td class="right bold" style="font-size:12px; padding-right:20px;">
        For ${companyName}<br/>
      </td>
    </tr>
    </table> 
    
    </body>
    </html>
    `;
    
    
    
        // Create an iframe for better printing
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "none";
        document.body.appendChild(iframe);
      
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(printableContent);
        doc.close();
      
        iframe.contentWindow.focus();
        setTimeout(() => {
          iframe.contentWindow.print();
          iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
        }, 500);
      };

  // dropdowns render into <body> so the scrolling item grid cannot clip them
  const menuPortalTarget =
    typeof document !== "undefined" ? document.body : null;
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  return (
    <div>
      <div
        className="modal fade show si-modal"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <div className="si-shell">
              <form
                id="invoice-content"
                className="si-form"
                onSubmit={handleSubmit(handleFormSubmit)}
              >
                {/* ---------- top bar ---------- */}
                <div className="si-topbar">
                  <button
                    type="button"
                    className="si-back"
                    onClick={handleClose}
                    aria-label="Close"
                  >
                    <ArrowLeft />
                  </button>
                  <div className="si-titles">
                    <h4>Delivery Note</h4>
                    <p>
                      {mode === "edit"
                        ? "Edit an existing delivery note"
                        : "Create a new delivery note"}
                    </p>
                  </div>
                  <button type="button" className="si-help" aria-label="Help">
                    <HelpCircle />
                  </button>
                </div>

                <div className="si-body">
                  {/* ---------- delivery note details ---------- */}
                  <div className="si-card si-card--details">
                    <div className="row">
                      {/* row1 */}
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field si-field--disabled">
                          <span className="si-field__icon">
                            <Hash />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Entry No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("entrynumber")}
                              required
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Calendar />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Date</label>
                            <Controller
                              control={control}
                              name="invdate"
                              render={({ field: { onChange, value } }) => (
                                <DatePicker
                                  className="datetimepicker"
                                  value={value ? dayjs(value) : dayjs()} // Set value or default to today
                                  format="DD-MM-YYYY"
                                  onChange={(date) =>
                                    onChange(
                                      date ? date.format("YYYY-MM-DD") : null
                                    )
                                  } // Update on change
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Clock />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Delivery Date
                            </label>
                            <Controller
                              control={control}
                              name="deliveryDate"
                              render={({ field: { onChange, value } }) => (
                                <DatePicker
                                  className="datetimepicker"
                                  value={value ? dayjs(value) : dayjs()} // Set value or default to today
                                  format="DD-MM-YYYY"
                                  onChange={(date) =>
                                    onChange(
                                      date ? date.format("YYYY-MM-DD") : null
                                    )
                                  } // Update on change
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <CreditCard />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Payment Type
                            </label>
                            <Controller
                              control={control}
                              name={`paymentType`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={paymentType}
                                  value={paymentType?.find(
                                    (paymentType) =>
                                      paymentType?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Link2 />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Reference Type
                            </label>
                            <Controller
                              control={control}
                              name={`referencetype`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={referencetype}
                                  value={referencetype?.find(
                                    (reference) => reference?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <FileText />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Reference No.
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("refNo")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--wide">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <User />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Customer</label>
                            <Controller
                              control={control}
                              name={`customer`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={customerData}
                                  value={customerData?.find(
                                    (customer) => customer?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                          <Link
                            to="#"
                            className="si-field__add"
                            onClick={() => {
                              setModalOpen(true);
                            }}
                          >
                            <Plus />
                          </Link>
                        </div>
                      </div>
                      {/* row 3 */}

                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Tag />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Sales Mode</label>
                            <Controller
                              control={control}
                              name={`salesMode`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={salesMode}
                                  value={salesMode?.find(
                                    (reference) => reference?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Home />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Ware House<span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="location"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={formattedWarehouses}
                                  required
                                  placeholder="Select Warehouse"
                                  value={getSelectedWarehouseOption(field.value)}
                                  onChange={(option) => field.onChange(option.value)}
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--narrow">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Send />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Dispatch</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("dispatch")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Truck />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Dispatch Through
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("dispatchTrough")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <MessageSquare />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("terms")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---------- delivery items ---------- */}
                  <div className="si-card si-card--items">
                    <div className="si-card-head">
                      <span className="si-head-icon">
                        <Box />
                      </span>
                      <h5>Delivery Items</h5>
                      <div className="si-head-actions">
                        <button
                          className="si-btn si-btn--soft si-btn--sm"
                          type="button"
                          onClick={handleAddRow}
                        >
                          <Plus />
                          Add Item
                        </button>
                      </div>
                    </div>

                    <div className="si-table-wrap">
                      <table
                        className="table si-table"
                        style={{
                          minWidth:
                            branchsettings?.disableTaxInSale == false
                              ? "1368px"
                              : "1238px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th className="si-th-name">Description</th>
                            <th className="si-th-code">Item Code</th>
                            {/* <th className="sticky-header">HSN Code</th> */}
                            <th className="si-th-unit">Unit</th>
                            <th className="si-th-batch">Batch</th>
                            <th className="si-th-date-lg">Exp Date</th>
                            <th className="si-th-qty">Qty</th>
                            <th className="si-th-num">Price</th>
                            <th className="si-th-num">MRP</th>
                            <th className="si-th-qty">FOC</th>
                            <th className="si-th-num">Gross</th>
                            <th className="si-th-sel">Disc %</th>
                            <th className="si-th-num">Disc Amt</th>
                            {branchsettings?.disableTaxInSale == false && (
                              <th className="si-th-tax">Tax %</th>
                            )}
                            {branchsettings?.disableTaxInSale == false && (
                              <th className="si-th-num">Tax Amt</th>
                            )}
                            <th className="si-th-num">Net Amt</th>
                            <th className="si-th-act">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fields?.map((field, index) => {
                            return (
                              <tr key={field.id}>
                                <td data-label="Description">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].product`}
                                    rules={{
                                      required: "Product is required",
                                      validate: (value) => {
                                        const selectedProducts = watch(
                                          "items"
                                        )?.map((item) => item.product); // Get all selected products
                                        const isDuplicate =
                                          selectedProducts?.filter(
                                            (product) => product === value
                                          )?.length > 1;

                                        return isDuplicate
                                          ? "Duplicate product selected!"
                                          : true;
                                      },
                                    }}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        options={formatedproductList}
                                        value={formatedproductList?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                          handleEachProductfetch(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        menuPortalTarget={menuPortalTarget}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.product && (
                                      <span className="si-err">
                                        {errors.items[index].product.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Item Code">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].code`)}
                                    disabled
                                  />
                                </td>
                                {/* <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].hsnCode`)}
                                    disabled
                                  />
                                </td> */}
                                <td data-label="Unit">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].unit`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        options={unitData}
                                        value={unitData?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                        }}
                                        isDisabled={true}
                                      />
                                    )}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].batch`)}
                                  />
                                </td>
                                <td>
                                  <Controller
                                    control={control}
                                    name={`items[${index}].expiry`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <DatePicker
                                        className="datetimepicker"
                                        placeholder={
                                          value ? dayjs(value) : dayjs()
                                        }
                                        value={value ? dayjs(value) : dayjs()}
                                        format="DD-MM-YYYY"
                                        onChange={(date) => onChange(date)}
                                      />
                                    )}
                                  />
                                </td>
                                <td data-label="Quantity" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].quantity`, {
                                      required: "Quantity is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "Quantity must be a positive number",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.quantity && (
                                      <span className="si-err">
                                        {errors.items[index].quantity.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Price" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].price`, {
                                      required: "Price is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "Price must be a positive number",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.price && (
                                      <span className="si-err">
                                        {errors.items[index].price.message}
                                      </span>
                                    )}
                                </td>
                                <td className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].mrp`, {
                                      validate: (value) =>
                                        (!isNaN(value) && value >= 0) ||
                                        "MRP must be zero or more",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.mrp && (
                                      <span className="si-err">
                                        {errors.items[index].mrp.message}
                                      </span>
                                    )}
                                </td>
                                <td className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].foc`, {
                                      validate: (value) =>
                                        (!isNaN(value) && value >= 0) ||
                                        "FOC must be zero or more",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.foc && (
                                      <span className="si-err">
                                        {errors.items[index].foc.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Gross" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].gross`)}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <Controller
                                    control={control}
                                    name={`items[${index}].discountPercentage`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        options={discountData}
                                        isClearable
                                        value={
                                          discountData?.find(
                                            (option) => option.value === value
                                          ) ?? null
                                        }
                                        onChange={(selectedOption) =>
                                          onChange(
                                            selectedOption
                                              ? selectedOption.value
                                              : null
                                          )
                                        }
                                        menuPortalTarget={menuPortalTarget}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                </td>
                                <td data-label="Discount Amount" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(
                                      `items[${index}].discountAmount`
                                    )}
                                    disabled
                                  />
                                </td>
                                {branchsettings?.disableTaxInSale ==
                                  false && (
                                  <td data-label="Tax %">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].taxPercentage`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={taxData}
                                          value={taxData?.find(
                                            (option) => option.guid === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                          }}
                                          isDisabled={true}
                                          menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                        />
                                      )}
                                    />
                                  </td>
                                )}
                                {branchsettings?.disableTaxInSale ==
                                  false && (
                                  <td data-label="Tax Amount" className="si-cell-num">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(
                                        `items[${index}].taxAmount`
                                      )}
                                      disabled
                                    />
                                  </td>
                                )}
                                <td data-label="Net Amount" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].netTotal`)}
                                    disabled
                                  />
                                </td>
                                <td className="si-row-del">
                                  <Link
                                    to="#"
                                    className="si-del-btn confirm-text"
                                    onClick={() => remove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ---------- delivery note summary ---------- */}
                  <div className="si-card si-card--summary">
                    <div className="si-card-head">
                      <span className="si-head-icon">
                        <FileText />
                      </span>
                      <h5>Delivery Note Summary</h5>
                    </div>

                    <div className="si-summary">
                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Plus />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Addition</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={0}
                              {...register(`addition`)}
                            />
                            {errors.addition && (
                              <span className="si-err">
                                {errors.addition.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Minus />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Discount</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={0}
                              {...register(`subtraction`, {
                                validate: (value) => {
                                  const discount = safeNumber(value);
                                  const totalNetAfterDiscount =
                                    totalNet - discount;

                                  if (discount < 0) {
                                    return "Discount value should not be negative.";
                                  } else if (totalNetAfterDiscount < 0) {
                                    return "Please enter a discount value that does not exceed the Net Total.";
                                  }
                                  return true;
                                },
                              })}
                            />
                            {errors.subtraction && (
                              <span className="si-err">
                                {errors.subtraction.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Shuffle />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Round Off</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={0}
                              {...register(`round`, {
                                validate: (value) => {
                                  const round = safeNumber(value);
                                  const totalNetAfterRound = totalNet - round;
                                  return (
                                    totalNetAfterRound >= 0 ||
                                    "Please enter a round-off value that does not exceed Net Total."
                                  );
                                },
                              })}
                            />
                            {errors.round && (
                              <span className="si-err">
                                {errors.round.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <span className="si-sum-sep" />

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Database />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Gross</label>
                            <span
                              className="si-value"
                              title={totalGross?.toFixed(decimalpoints)}
                            >
                              {totalGross?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Percent />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Discount</label>
                            <span
                              className="si-value"
                              title={totalDiscount?.toFixed(decimalpoints)}
                            >
                              {totalDiscount?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <FileText />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Tax Total</label>
                            <span
                              className="si-value"
                              title={totalTax?.toFixed(decimalpoints)}
                            >
                              {totalTax?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value si-sum-total">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <FileText />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Net Total</label>
                            <span
                              className="si-value"
                              title={totalNet?.toFixed(decimalpoints)}
                            >
                              {totalNet?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ---------- footer ---------- */}
                <div className="si-footer">
                  <button
                    type="button"
                    className="si-btn"
                    onClick={() => resetmodal()}
                  >
                    <RotateCcw />
                    Reset
                  </button>

                  <div className="si-footer-right">
                    <button
                      type="submit"
                      className="si-btn si-btn--accent"
                      onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
                    >
                      <Printer />
                      Save &amp; Print
                    </button>
                    <button className="si-btn si-btn--primary" type="submit">
                      <Check />
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && (
        <CustomerModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default DeliveryNoteModal;
